import { useState } from "react";
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import { Button, Form, Space, Spin, Tabs } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import SweetAlert from "sweetalert2";
import { Crypter } from "../../../Functions/Security/Crypter";
import Data from '../../../Data/Data.json';
import axios from "axios";
import Tab1 from "./Tab1";
import { Typography } from "@mui/material";

const PointStockagePage = () => {
    const auth = useAuthUser();
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()));
    const authHeader = useAuthHeader();
    const [form] = Form.useForm();

    // États de l'interface
    const [loading, setLoading] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Enrege, setEnrege] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [EtatG, setEtatG] = useState(false); 
    const [sbmit, setSbmit] = useState("");

    // --- PHASE 1 : CONSULTATION ---
    function HandleConsult() {
        const code = form.getFieldValue("CODEPOINT");
        if (!code) {
            SweetAlert.fire("Alerte", "Veuillez choisir un point de stockage.", "warning");
            return;
        }

        setLoading(true);
        axios.get(Data.ApiUrl.ReadPointStockage, {
            headers: { 'Authorization': authHeader(), 'CypheCodePoint': Crypter.encrypt (code) }
        })
        .then((response) => {
            const decryptedData = Crypter.decrypt(response.data);
            const parsed = JSON.parse(decryptedData);
            const res = parsed.Value ? parsed.Value : parsed;

            if (res.StatutCode === 200) {
                const d = (res.Result && res.Result.Table) ? res.Result.Table[0] : (res.Result ? res.Result[0] : null); 

                if (d) {
                // Mapping DTO C# (PascalCase) -> Formulaire (UPPERCASE)
                form.setFieldsValue({
                    // Localisation Point de stockage
                    CODEPOINT: d.CodePoint,
                    LIBELLE: d.Libelle,
                    ADDRESS: d.Address,
                    CODEVILLE: d.CodeVille,  
                    lib_CODEVILLE: d.Libell,
                    CODEPAYS: d.CodePays,  
                    lib_CODEPAYS: d.LIBELL,
                    CODEPOSTAL: d.CodePostal,
                    // Details technique
                    CAPACITESTOCKAGE: d.CapaciteStockage,
                    ESTPROPRE: d.EstPropre,
                    ESTASSURE: d.EstAssure,
                    ISACTIVE: d.IsActive,
                    // Champs informatifs / Audit
                    DATEDERNIERINVENTAIRE: d.DateDernierInventaire ? new Date(d.DateDernierInventaire).toLocaleDateString(): "",
                    CREATEDBY: d.CreatedBy,
                    DATECREATION: d.DateCreation ? new Date(d.DateCreation).toLocaleDateString() : "",
                    UPDATEDBY: d.UpdatedBy,
                    DATEMODIFICATION: d.DateModification ? new Date(d.DateModification).toLocaleDateString() : ""
                });

                setModife(false);
                setAnnule(false);
                setConsulte(true);
            }
            } else {
                SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" });
            }
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.error("Erreur technique de consultation :", err);
            SweetAlert.fire("Erreur", "Impossible de joindre le serveur", "error");
        });
    }

    // --- PHASE 3 : CRÉATION ---
    function HandleAjout() {
        form.resetFields();
        setConsulte(true);
        setAjoute(true);
        setEnrege(false);
        setAnnule(false);
        setEtatG(true);
        setFormactve(false);
        setSbmit('add');
    }

    // --- PHASE 2 : MODIFICATION ---
    function HandleModif() {
        setEnrege(false);
        setModife(true);
        setEtatG(true);
        setFormactve(false);
        setSbmit('modif');
    }

    // --- RÉINITIALISATION ---
    function HandleAnnul() {
        setEtatG(false);
        setConsulte(false);
        setAjoute(false);
        setModife(true);
        setEnrege(true);
        setAnnule(true);
        form.resetFields();
        setFormactve(true);
        setSbmit('');
    }

    // --- PHASE 4 : ENGAGEMENT (SAVE/UPDATE) ---
    const onFinish = (values: any) => {
        const isAdd = sbmit === "add";
        const url = isAdd ? Data.ApiUrl.CreatePointStockage : Data.ApiUrl.UpdatePointStockage;

        // Préparation du DTO C#
        const payload = {
            CodePoint: values.CODEPOINT || "",
            Libelle: values.LIBELLE,
            Address: values.ADDRESS,
            CodeVille: values.CODEVILLE,
            CodePostal: values.CODEPOSTAL,
            CodePays: values.CODEPAYS,
            CapaciteStockage: values.CAPACITESTOCKAGE || 0,
            EstPropre: values.ESTPROPRE || false,
            EstAssure: values.ESTASSURE || false,
            IsActive: values.ISACTIVE || false,
            CreatedBy: isAdd ? Perss.coduti : values.CREATEDBY,
            UpdatedBy: Perss.coduti
        };

        SweetAlert.fire({
            title: isAdd ? "Enregistrement" : "Modification",
            text: `Voulez-vous valider le point de stockage : ${values.LIBELLE} ?`,
            showCancelButton: true,
            confirmButtonColor: "green",
            cancelButtonColor: "darkred",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            icon: 'question'
        }).then((res) => {
            if (res.isConfirmed) {
                setLoading(true);
                let encryptedData = Crypter.encrypt(JSON.stringify(payload));

                const config = {
                    method: isAdd ? 'post' : 'put',
                    url: url,
                    data: encryptedData,
                    headers: { 'Authorization': authHeader(), 'Content-Type': 'application/json' }
                };

                axios(config).then((response) => {
                    setLoading(false);
                    const resJson = JSON.parse(Crypter.decrypt(response.data));
                    const finalRes = resJson.Value || resJson;

                    if (finalRes.StatutCode === 200 || finalRes.statutCode === 200) {
                        SweetAlert.fire("Succès", finalRes.Message, "success");
                        HandleAnnul();
                    } else {
                        SweetAlert.fire({ title: finalRes.Message, text: finalRes.Result, icon: "warning" });
                    }
                }).catch(() => {
                    setLoading(false);
                    SweetAlert.fire("Erreur", "Le serveur a refusé la transaction", "error");
                });
            }
        });
    };

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: <span><UserOutlined /> Détails Point de Stockage</span>,
            children: <Tab1
                EtatG={EtatG}
                form={form}
                disabledForm={FormAct}
                sbmit={sbmit}
            />
        }
    ];

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'>
                <b> GESTION DES POINTS DE STOCKAGE </b>
            </Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }}>
                <Form form={form} onFinish={onFinish} preserve labelAlign="left">
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' disabled={Consultactv} onClick={HandleConsult} block>Consulter</Button>
                                <Button size='large' disabled={Ajoutactv} onClick={HandleAjout} block>Ajouter</Button>
                                <Button size='large' disabled={Modifactv} onClick={HandleModif} block>Modifier</Button>
                                <Button size='large' disabled={Enrege} htmlType="submit" block>Enregistrer</Button>
                                <Button size='large' disabled={Annulactv} onClick={HandleAnnul} block>Annuler</Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                    </div>
                </Form>
            </Spin>
        </div>
    );
};

export default PointStockagePage;